export const adaptComboAdicional = (combo) => {
    return {
        id: combo?.idComboRIValor,
        displayName: combo?.valor,
        value: combo?.idComboRIValor,
        label: combo?.valor
    }
}

export const adaptAdicionalArray = (combos) => {
    return (
        Object.fromEntries(
            Object.entries(combos).map(
                ([key, value]) => {
                    return [key, value.comboRIValor.map(comboValor => adaptComboAdicional(comboValor))]
                }
            )
        )
    )
}